const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20courtyard%20with%20blossoming%20plum%20trees%2C%20warm%20soft%20sunlight%2C%20ancient%20architecture%20details%2C%20poetic%20atmosphere%2C%20cinematic%20period%20drama%20aesthetic%2C%20gentle%20color%20palette%20of%20cream%20and%20terracotta&width=600&height=400&seq=97cinema-card-1&orientation=landscape',
    title: '国产古装精选',
    desc: '朝堂权谋 · 江湖武侠 · 宫闱传奇',
    meta: '收录 3600+ 部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20modern%20Seoul%20apartment%20interior%20with%20soft%20ambient%20lighting%2C%20cozy%20romantic%20atmosphere%2C%20minimalist%20Korean%20aesthetic%2C%20gentle%20pastel%20tones%2C%20cinematic%20intimate%20mood%2C%20clean%20contemporary%20design&width=600&height=400&seq=97cinema-card-2&orientation=landscape',
    title: '韩剧浪漫剧场',
    desc: '虐心虐恋 · 甜蜜治愈 · 奇幻爱情',
    meta: '收录 2100+ 部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20urban%20alleyway%20at%20night%20with%20warm%20street%20lamp%20glow%2C%20film%20noir%20atmosphere%2C%20mysterious%20cinematic%20composition%2C%20deep%20shadows%20and%20amber%20highlights%2C%20suspenseful%20premium%20TV%20drama%20aesthetic&width=600&height=400&seq=97cinema-card-3&orientation=landscape',
    title: '美剧犯罪悬疑',
    desc: '真实案件 · 心理惊悚 · 法律博弈',
    meta: '收录 1800+ 部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20cloud%20landscape%20with%20floating%20celestial%20palaces%2C%20soft%20magical%20golden%20light%2C%20dreamy%20fantasy%20atmosphere%2C%20traditional%20Chinese%20mythology%20aesthetic%2C%20pearly%20mist%20and%20jade%20green%20tones%2C%20cinematographic%20composition&width=600&height=400&seq=97cinema-card-4&orientation=landscape',
    title: '仙侠奇幻世界',
    desc: '修仙问道 · 三界争锋 · 上古传说',
    meta: '收录 1500+ 部',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20sunny%20modern%20city%20rooftop%20garden%20with%20cityscape%20background%2C%20golden%20hour%20lighting%2C%20romantic%20atmospheric%20mood%2C%20contemporary%20urban%20lifestyle%20aesthetic%2C%20soft%20focus%2C%20premium%20editorial%20photography%20style&width=600&height=400&seq=97cinema-card-5&orientation=landscape',
    title: '都市情感剧场',
    desc: '职场奋斗 · 都市爱情 · 家庭伦理',
    meta: '收录 2800+ 部',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            五大品类精选好剧，总有一部适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLImageElement).setAttribute('data-error', 'true'); }}
                />
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 mb-2">{card.desc}</p>
                <div className="mt-auto pt-2 border-t border-background-200/50">
                  <span className="text-xs text-accent-600 font-medium">{card.meta}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}